import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NodeFieldsDataService } from '../../services/data.service';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.css'],
  standalone: false,
})
export class NodeFieldDeleteDialogComponent {
  public field;
  public fieldLabel: string = '';

  constructor(
    public dialogRef: MatDialogRef<NodeFieldDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public deleteData: any,
    public dataService: NodeFieldsDataService,
  ) {
    this.field = deleteData['data']['field']['name'];
    // this.fieldLabel = deleteData['data']['fieldLabel'];
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  confirmDelete(): void {
    // this.dataService.deleteRecord(this.data['catchindex']);
  }
}
